var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApiModel } from "./api-model";
var EventArticle = /** @class */ (function (_super) {
    __extends(EventArticle, _super);
    function EventArticle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Remove picture raw data to avoid heavy request
     */
    EventArticle.prototype.cleanPicture = function (blob) {
        if (this.translations && this.translations.length > 0) {
            this.translations = this.translations.map(function (t) {
                if (t.value["picture"]) {
                    var formats = [
                        "original",
                        "format_16_9",
                        "format_4_3",
                        "format_3_4",
                    ];
                    formats.forEach(function (format) {
                        if (t.value.picture[format]) {
                            t.value.picture[format].displayUrl = null;
                            if (blob && t.value.picture[format].blob) {
                                t.value.picture[format].blob = null;
                            }
                        }
                    });
                }
                return t;
            });
        }
    };
    return EventArticle;
}(ApiModel));
export { EventArticle };



// WEBPACK FOOTER //
// ./src/app/models/event-article.ts.pre-build-optimizer.js